<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="planName" placeholder="请输入计划名称" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="status" collapse-tags filterable clearable placeholder="选择状态">
            <el-option v-for="item in statusList" :key="item.id" :value="item.id" :label="item.name" style="width: 180px"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="adAccountIdList" multiple collapse-tags filterable clearable placeholder="选择账号">
            <el-option v-for="item in accountData" :key="item.id" :value="item.id" :label="item.name" style="width: 220px"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="upOpIdList" multiple collapse-tags filterable clearable placeholder="选择最后操作人">
            <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <DateRangePicker v-model="datetime" :clearable="false" style="width: 220px"></DateRangePicker>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import DateRangePicker from '@/components/date-range-picker/index.vue'
import moment from 'moment'
const statusList = [
  { name: '成功', id: 1 },
  { name: '失败', id: 0 }
]
const now = moment().format('YYYY-MM-DD')
const start = moment().format('YYYY-MM-01')
export default {
  name: 'listFilter',
  components: { DateRangePicker },
  props: {
    accountData: {
      type: Array
    },
    operatorData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const [begin, end] = this.datetime
      const params = {
        keyword: this.planName,
        status: this.status,
        adAccountIdList: this.adAccountIdList,
        upOpIdList: this.upOpIdList,
        beginTime: begin,
        endTime: end
      }
      this.$emit('on-change', params)
    }
  },
  data() {
    return {
      datetime: [],
      planName: '',
      upOpIdList: [],
      adAccountIdList: [],
      status: '',
      statusList
    }
  },
  created() {
    this.datetime = [start, now]
    this.sendEvent()
  }
}
</script>
